import type { ColumnDef } from "@tanstack/react-table";
import { Stack } from "@volca/ui/components/ui/stack";
import { RUN_STATUS } from "@/profitability/constants";
import { MissingNote, showValue } from "@/profitability/missing-value";
import { ReportMetadata } from "@/profitability/report-presentation";
import type { EnrichedProfitabilityPeriod } from "@/profitability/types";
// The API owns summary order and labels. Web formats their values.
export const ReportResult = ({ run }: { run: EnrichedProfitabilityPeriod }) => {
  if (run.status !== RUN_STATUS.completed || !run.summary.length)
    return <span className="text-subtle">No result</span>;

  const [headline] = run.display.summary;
  return (
    <Stack align="start" gap={0}>
      <span className="font-medium tabular-nums">
        {showValue(headline.displayValue)}
        <span className="ml-1.5 text-xs font-normal text-subtle">
          {headline.inlineLabel}
        </span>
      </span>
      {/* Rows with no value for it, left out of the figure (FIN-004). */}
      <MissingNote count={headline.missing} label={headline.label} />
      {!!run.display.supportingFigures.length && (
        <ReportMetadata className="text-xs text-subtle tabular-nums">
          {run.display.supportingFigures}
        </ReportMetadata>
      )}
    </Stack>
  );
};

export const resultCol: ColumnDef<EnrichedProfitabilityPeriod> = {
  id: "result",
  header: "Result",
  // Figures can differ between published versions, so results are not sortable.
  enableSorting: false,
  meta: { size: "230px" },
  cell: ({ row }) => <ReportResult run={row.original} />,
};
